import React, { PropsWithChildren } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import * as S from './styles';

type Props = {
  open: boolean;
  isError?: boolean;
  icon?: React.ReactNode;
  content: React.ReactNode;
  top?: number;
  left?: number;
} & PropsWithChildren;

export const InfoBanner: React.FC<Props> = ({
  open,
  isError,
  icon,
  content,
  top,
  left,
}) => {
  return (
    <AnimatePresence>
      {open && (
        <motion.div
          initial={{ opacity: 0, y: 8 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.25, ease: [0.33, 1, 0.68, 1] }}
        >
          <S.Container isError={isError} top={top} left={left}>
            {icon}
            {content}
          </S.Container>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
